// extracted by mini-css-extract-plugin
export var container = "_ls-0";
export var segment = "_ls-2";
export var segmentActive = "_ls-3";
export var track = "_ls-1";